import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, PrimaryGeneratedColumn } from 'typeorm';
import { ApparelArticleMasterVersions } from './apparel-article-masters-versions.entity';

@Entity('_versions_measurement_chart_months')
export class MeasurementChartMonthsVersions {
  @PrimaryGeneratedColumn()
  id: number;

  @Column({ name: 'pom_name', type: 'varchar', length: 255 })
  pomName: string;

  @Column({ name: 'description', type: 'varchar', length: 255 })
  description: string;

  @Column({ name: 'pom_variation', type: 'varchar', length: 255 })
  pomVariation: string;

  @Column({ name: 'qc', type: 'varchar', length: 50 })
  qc: string;

  @Column({ name: 'tol_fraction_minus', type: 'varchar', length: 50 })
  tolFractionMinus: string;

  @Column({ name: 'tol_fraction_plus', type: 'varchar', length: 50 })
  tolFractionPlus: string;

  @Column({ name: 'tolerance_message', type: 'varchar', length: 255 })
  toleranceMessage: string;

  @Column({ name: 'grading_override_message', type: 'varchar', length: 255 })
  gradingOverrideMessage: string;

  @Column({ name: 'age_0_3_months', type: 'varchar', length: 50 })
  age0To3Months: string;

  @Column({ name: 'age_3_6_months', type: 'varchar', length: 50 })
  age3To6Months: string;

  @Column({ name: 'age_6_12_months', type: 'varchar', length: 50 })
  age6To12Months: string;

  @Column({ name: 'age_12_18_months', type: 'varchar', length: 50 })
  age12To18Months: string;

  @Column({ name: 'age_18_24_months', type: 'varchar', length: 50 })
  age18To24Months: string;


  @ManyToOne(() => ApparelArticleMasterVersions, (am) => am.versionsMeasurementChartMonths)
  @JoinColumn({ name: 'versions_apparel_article_id' })
  versionApparelArticleId: ApparelArticleMasterVersions

  @CreateDateColumn({
    name: "created_at",
  })
  createdAt: string;

  @Column("varchar", {
    nullable: true,
    length: 40,
    name: "created_user",
  })
  createdUser: string | null;

  @Column("varchar", {
    nullable: true,
    length: 40,
    name: "updated_user",
  })
  updatedUser: string | null;

  @CreateDateColumn({
    name: "updated_at",
  })
  updatedAt: string;
}
